import { IColumnModel } from '../../../../models/doview/column.model';

export const RUN_COL_CLASS = {
  type: 'runs-col runs-col-type',
  date: 'runs-col runs-col-date',
  label: 'runs-col runs-col-label',
  key: 'runs-col runs-col-key',
  summary: 'runs-col runs-col-summary',
  attachment: 'runs-col runs-col-attachment',
  priority: 'runs-col runs-col-priority',
  assignee: 'runs-col runs-col-assignee',
  status: 'runs-col runs-col-status',
};

export function buildCollapsedRunsColumns(): IColumnModel[] {
  return [
    {
      fieldId: '',
      fieldName: 'runDate',
      fieldDisplayName: 'runDate',
      fieldType: 'date',
      header: 'Last Updated',
      class: RUN_COL_CLASS.date,
      isProperty: true,
      isSortable: true,
      isEditable: false,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      sortField: 'runDate',
      width: '115px',
    },
    {
      fieldId: '',
      fieldName: 'labelName',
      fieldDisplayName: 'labelName',
      fieldType: 'text',
      header: 'Labels',
      class: RUN_COL_CLASS.label,
      isProperty: true,
      isSortable: true,
      isEditable: false,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      sortField: 'labelName',
      labelPathRenderer: true,
      tooltipFieldName: 'labelPath',
      width: 'auto',
    },
    {
      fieldId: '',
      fieldName: 'assignee',
      fieldDisplayName: 'assignee.fullName',
      fieldType: 'user',
      header: 'Assignee',
      class: RUN_COL_CLASS.assignee,
      isProperty: true,
      isSortable: true,
      isEditable: false,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      sortField: 'assignee.fullName',
      width: '70px',
    },
    {
      fieldId: '',
      fieldName: 'status',
      fieldDisplayName: 'status',
      fieldType: 'dropdown',
      header: 'Status',
      class: RUN_COL_CLASS.status,
      isProperty: true,
      isSortable: true,
      isEditable: false,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      statusRenderer: 'circle',
      width: '60px',
    },
  ];
}

export function buildExpandedRunsColumns(): IColumnModel[] {
  return [
    {
      fieldId: '',
      fieldName: 'type',
      fieldDisplayName: 'type',
      fieldType: 'type',
      header: 'Type',
      class: RUN_COL_CLASS.type,
      isProperty: true,
      isSortable: true,
      isEditable: false,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      sortField: 'nodeType',
      width: '120px',
    },
    {
      fieldId: '',
      fieldName: 'lastUpdatedDate',
      fieldDisplayName: 'lastUpdatedDate',
      fieldType: 'date',
      header: 'Last Updated',
      class: RUN_COL_CLASS.date,
      isProperty: true,
      isSortable: true,
      isEditable: false,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      sortField: 'lastUpdatedDate',
      showTime: true,
      width: '170px',
    },
    {
      fieldId: '',
      fieldName: 'labelName',
      fieldDisplayName: 'labelName',
      fieldType: 'text',
      header: 'Labels',
      class: RUN_COL_CLASS.label,
      isProperty: true,
      isSortable: true,
      isEditable: false,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      sortField: 'labelName',
      labelPathRenderer: true,
      tooltipFieldName: 'labelPath',
      width: '220px',
    },
    {
      fieldId: '',
      fieldName: 'key',
      fieldDisplayName: 'key',
      fieldType: 'text',
      header: 'Key',
      class: RUN_COL_CLASS.key,
      isProperty: true,
      isSortable: true,
      isEditable: false,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      sortField: 'key',
      width: '100px',
    },
    {
      fieldId: '',
      fieldName: 'name',
      fieldDisplayName: 'name',
      fieldType: 'text',
      header: 'Summary',
      class: RUN_COL_CLASS.summary,
      isProperty: true,
      isSortable: true,
      isEditable: true,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      sortField: 'name',
      width: '260px',
    },
    {
      fieldId: '',
      fieldName: 'due date',
      fieldDisplayName: 'dueDate',
      fieldType: 'date',
      header: 'Due Date',
      class: RUN_COL_CLASS.date,
      isProperty: true,
      isSortable: true,
      isEditable: true,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      sortField: 'dueDate',
      width: '130px',
    },
    {
      fieldId: '',
      fieldName: 'priority',
      fieldDisplayName: 'priority',
      fieldType: 'dropdown',
      header: 'Priority',
      class: RUN_COL_CLASS.priority,
      isProperty: true,
      isSortable: true,
      isEditable: true,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      width: '110px',
    },
    {
      fieldId: '',
      fieldName: 'assignee',
      fieldDisplayName: 'assignee.fullName',
      fieldType: 'user',
      header: 'Assignee',
      class: RUN_COL_CLASS.assignee,
      isProperty: true,
      isSortable: true,
      isEditable: true,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      sortField: 'assignee.fullName',
      width: '110px',
    },
    {
      fieldId: '',
      fieldName: 'attachment',
      fieldDisplayName: 'attachment',
      fieldType: 'attachment',
      header: 'Attachment',
      class: RUN_COL_CLASS.attachment,
      isProperty: true,
      isSortable: false,
      isEditable: false,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      width: '80px',
    },
    {
      fieldId: '',
      fieldName: 'status',
      fieldDisplayName: 'status',
      fieldType: 'dropdown',
      header: 'Status',
      class: RUN_COL_CLASS.status,
      isProperty: true,
      isSortable: true,
      isEditable: false,
      isFrozen: false,
      isScrollable: true,
      isToggleColumn: false,
      statusRenderer: 'pill',
      width: '140px',
    },
  ];
}

export function hydrateColumnFieldIds(columns: IColumnModel[], fieldIdDictionary: Record<string, string>): IColumnModel[] {
  if (!columns || !fieldIdDictionary) return columns ?? [];
  return columns.map((col) => {
    const lowerName = (col.fieldName || '').toLowerCase();
    const hydrated: IColumnModel = { ...col };
    if (fieldIdDictionary[lowerName]) {
      hydrated.fieldId = fieldIdDictionary[lowerName];
    } else if (lowerName === 'name' && fieldIdDictionary['summary']) {
      // The Summary column uses fieldName 'name' but the blueprint field may be called 'summary'.
      hydrated.fieldId = fieldIdDictionary['summary'];
    }
    return hydrated;
  });
}
